import { createActions } from 'redux-actions';

export const actions = createActions(
  {},

  'CONVERSATIONS_INCREASING_UNREAD',
  'CONVERSATIONS_RESET_UNREAD',

  'CONVERSATIONS_ADD',
  'CONVERSATIONS_REMOVE',

  'CONVERSATIONS_UPDATE_USER',
  'CONVERSATIONS_UNASSIGN_SELF',
  'CONVERSATIONS_CLOSE_CONVERSATION',
  'CONVERSATIONS_CONVERSATION_TO_PENDING',
  'CONVERSATIONS_CONVERSATION_CANCEL_PENDING',
  'CONVERSATIONS_CONVERSATION_OFFER_ACCEPTED',
  'CONVERSATIONS_CONVERSATION_CLAIMED',
  'CONVERSATIONS_CONVERSATION_TRANSFERED',
  'CONVERSATIONS_CONVERSATION_ASSISTED_TRANSFER_ACCEPTED',
  'CONVERSATIONS_UPDATE',
  'CONVERSATIONS_SET',
  'SYNC_SIDEBAR_CONVERSATIONS',
  'CONVERSATIONS_CONVERSATION_CHANNEL_CHANGED',
  'CONVERSATIONS_MARK_SEEN',
);
